import { gql } from '@apollo/client'
import { BodyText, Card, Heading, Subtitle } from '@farol-ds/react'

import { SinglePlanCard_OfferLockDataFragment } from './__generated__/single-plan-card.graphql'
import styles from './case-tracking-bg-check-from-lawsuit-offers.module.scss'

interface SinglePlanCardProps {
  offerLockData: SinglePlanCard_OfferLockDataFragment
}

export default function SinglePlanCard({ offerLockData }: SinglePlanCardProps) {
  const { body } = offerLockData || {}
  const { cards } = body || {}
  const card = cards[0]

  if (!card) return null

  return (
    <div className={styles.singlePlanCardContainer}>
      <Card className={styles.singlePlanCard}>
        <div className={styles.caseTrackingBgCheckFromLawsuitOffersCardContentTitle}>
          <Heading className={styles.caseTrackingBgCheckFromLawsuitOffersCardTitle} size="md">
            {card.title}
          </Heading>{' '}
          <Subtitle className={styles.caseTrackingBgCheckFromLawsuitOffersCardSubtitle} size="md">
            <span dangerouslySetInnerHTML={{ __html: `${card.subtitle}` }} />
          </Subtitle>
        </div>
        <BodyText size="md">
          <span
            dangerouslySetInnerHTML={{ __html: `${card.offer.priceText} ${card.offer.frequency}` }}
          />
        </BodyText>
      </Card>
    </div>
  )
}

SinglePlanCard.fragments = {
  offerLockData: gql`
    fragment SinglePlanCard_offerLockData on OfferLockData {
      body {
        cards {
          title
          subtitle
          offer {
            frequencyPeriodText
            priceText
            frequency
          }
          button {
            label
          }
        }
      }
    }
  `,
}
